// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1_s_R-","leftContent":"_1GUlE-","rightContent":"_1_WVo-"};